import React, { Fragment, Component } from 'react';
import { Image, Row, Col, Button } from "react-bootstrap";
import GoalScoreArea from "../../../ui/canvases/GoalScoreArea";
import GoalsMap from "./components/GoalMap";

import { ReactComponent as IconLeft } from "../../../../assets/svg/actions/icn-chevron-left.svg";
import { ReactComponent as IconRight } from "../../../../assets/svg/actions/icn-chevron-rigth-24px.svg";

import markWillsAvatar from "../../../../assets/img/demo/player-evaluation-avatar-11.png";
import eduardoMilesAvatar from "../../../../assets/img/demo/player-evaluation-avatar-12.png";
import dustinWilliamsonAvatar from "../../../../assets/img/demo/player-evaluation-avatar-13.png";

// TODO: Fetch goals from API.
// Goal area [ x: [-160, 160] y:[], z:[0, 150]

const goal1 = {
    steps: [
        { x: -250, y: 100, name: "Eduardo Miles", avatar: markWillsAvatar },
        { x: -50, y: 250, name: "Dustin Williamson", avatar: dustinWilliamsonAvatar },
        { x: -200, y: 450, name: "Mark Wills", avatar: eduardoMilesAvatar },
        { x: 110, y: 600, z: 40, isGoal: true },
    ],
    order: 1,
    minuets: 62,
};
const goals = [goal1];

class PlayerStatistics extends Component {

    constructor(props) {
        super(props);

        this.state = {
            goals: goals,
            dx: 1,
            dy: 1,
            dz: 1.
        };
    }

    render() {
        return (
            <div className="center-content player-statistics">
                <Row gutter>
                    <Col md={7}>
                        {this.renderGoalMap()}
                    </Col>
                    <Col md={5}>
                        {this.renderGoals()}
                    </Col>
                </Row>
            </div>
        );
    };

    renderGoalMap = () => {
        const { goals } = this.state;

        return (
            <GoalsMap goals={goals} />
        );
    };

    renderGoals = () => {
        const { goals } = this.state;

        return (
            <div className="goals">
                {goals.map((goal) => this.renderGoal(goal))}
            </div>
        );
    };

    renderGoal = (goal, index) => {
        const { steps, order, minuets } = goal;
        return (
            <div className="goal" key={index}>
                {this.renderGoalSteps(steps)}
                {this.renderGoalInfo(goal)}
                {this.renderControls()}
            </div>
        );
    };

    renderGoalSteps = (steps) => {
        return (
            <div className="steps-container">
                <div className="steps-player">
                    {steps.filter(step => !step.isGoal).map((step, index) => this.renderGoalStep(step, index))}
                </div>
                <div className="steps-goal">
                    {steps.filter(step => step.isGoal).map((step, index) => this.renderGoalStep(step, index))}
                </div>
            </div>
        );
    };

    renderGoalStep = (step, index) => {
        const { isGoal } = step;
        if (isGoal) {
            return this.renderScoreGoal(step);
        } else {
            return this.renderPlayerStep(step, index);
        }
    };

    renderScoreGoal = (goalStep) => {
        const { x, z } = goalStep;
        // x: [-160 -> 160]
        // z: [0 -> 150]

        const goalScoreAreaText = this.goalScoreAreaText();
        return (
            <Fragment>
                {this.renderArrow()}
                <div className="goal-step">
                    <GoalScoreArea ball={{ x: x, z: z }} />
                    <div className="text"> {goalScoreAreaText} </div>
                </div>
            </Fragment>
        );
    };

    renderPlayerStep = (playerStep, index) => {
        const { name, avatar } = playerStep;
        return (
            <Fragment>
                {index !== 0 && this.renderArrow()}
                <div className="player-step">
                    <Image roundedCircle src={avatar} />
                    <div className="name"> {name} </div>
                </div>
            </Fragment>
        )
    };

    renderArrow = () => {
        return (
            <div className="arrow vertical">
                <div className="line" />
                <span className="top-vertex" />
            </div>
        );
    };

    renderGoalInfo = (goal) => {
        return (
            <div className="goal-info">
                <div className="info">
                    <h6 className="title">Accuracy</h6>
                    <p className="text">89</p>
                </div>
                <div className="info">
                    <h6 className="title">Difficulty</h6>
                    <p className="text">Hard</p>
                </div>
            </div>
        )
    }

    renderControls = () => {
        return (
            <div className="btn-controls-container">
                <Button className="btn-control" variant="primary"><IconLeft /></Button>
                <Button className="btn-control" variant="primary"><IconRight /></Button>
            </div>
        )
    }

    goalScoreAreaText = () => "Goal Score Area";
}

export default PlayerStatistics;
